// extracted by mini-css-extract-plugin
export default {"customModalWidth":"Modal_customModalWidth__BA+Sb"};